import styled, { css } from 'styled-components';

type RadioProps = {
  active: boolean;
};

export function Radio({ active }: RadioProps) {
  return <Container $active={active}>{active && <Dot />}</Container>;
}

const Container = styled.div<{
  $active: boolean;
}>`
  ${({ theme, $active }) => css`
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 50%;
    position: relative;
    transition: background-color 0.1s;
    background-color: ${$active
      ? theme.radioControl.activeBackgroundColor
      : theme.radioControl.backgroundColor};
    ${!$active &&
    css`
      border: 1px solid ${theme.radioControl.borderColor};
    `};

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  `}
`;

const Dot = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    height: 50%;
    border-radius: 50%;
    background-color: ${theme.radioControl.dotColor};
  `}
`;
